// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2QWp6","title":"BackImages_title__2CpBR","images":"BackImages_images__2BWZt"};